import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Table, Empty } from 'antd';
import Icofont from 'react-icofont';

import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';

import {
    MoreOutlined
} from '@ant-design/icons';



import { Action, GETWITH, QueryDetail, deleteInArray, updateInArray } from 'fennec-ui'
import { DropdownAction } from 'fennec-ui'
import KategoriiUchastnikovNaMeropriyatiyakh from '../KategoriiUchastnikovNaMeropriyatiyakh'
import { errorCatch, POST } from 'fennec-ui'

import "./index.css"
import KategoriiUchastnikovNaMeropriyatiyakhUpdate from '../KategoriiUchastnikovNaMeropriyatiyakhUpdate';

const DragHandle = sortableHandle(() => <Icofont icon="expand-alt" style={{ cursor: 'grabbing', color: '#999' }} />);
const SortableItem = sortableElement(props => <tr {...props} />);
const SortableContainer = sortableContainer(props => <tbody {...props} />);


export default function KategoriiUchastnikovNaMeropriyatiyakhList(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, item, sourceKey, create, collection, updateEvent } = props;

    const dispatch = useDispatch();

    const [_kategorii, setKategorii] = useState([])
    useEffect(()=>{
        setLoading(true)
        GETWITH(auth, `/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/list/${object.ID}`,
            [
                QueryDetail("kurator")
            ],
            ({data}) => {
                setKategorii(data)
                setLoading(false)
            }, 
            (err) => errorCatch(err, ()=>setLoading(false))
        )
    }, [object])

    // const _kategorii = (object.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie) ? [...object.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie] : [];
    const kategorii = _kategorii.sort((a, b) => {
        return a.sort - b.sort;
    }).map((item, index) => {
        return { ...item, sort: index };
    });

    const kat_delete = React.useCallback((kat) => {
        if (!create) return;
        // /api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/delete
        setLoading(true)
        POST(auth, "/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/delete", kat,
            () => {
                setKategorii(o=>deleteInArray(o, kat))
                // updateEvent({
                //     ...object,
                //     kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie: deleteInArray(object.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, kat)
                // })
                setLoading(false)
            },
            (err) => errorCatch(err, ()=>setLoading(false)));
    }, [sourceKey, object]);
    const postSetOrder = (kategorii) => {
        if (!create) return;
        setLoading(true);
        POST(auth, "/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/sort", kategorii,
            ({ data }) => {
                setKategorii(data)
                // updateEvent({
                //     ...object,
                //     kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie: data
                // })
                setLoading(false);
            },
            (err) => errorCatch(err, setLoading(false)));
    };
    const columns = () => {
        var c = [];

        if (create) {
            c.push({
                width: 30,
                className: 'drag-visible',
                render: () => <DragHandle />,
            });
        }
        c.push({
            title: 'Танцевальная дисциплина',
            render: (text, record) => {
                return (
                    <div>
                        {record.tantsevalnayaDistsiplina.nazvanie}
                    </div>
                );
            },
            key: 'tantsevalnayaDistsiplina',
        });
        c.push({
            title: 'Категория участников',
            render: (text, record) => {
                return (
                    <div>
                        {record.kategoriyaUchastnikov.nazvanie}
                    </div>
                );
            },
            key: 'kategoriyaUchastnikov',
        });
        c.push({
            title: 'Сокращенное наименование',
            render: (text, record) => {
                return (
                    <div>
                        {record.shortName}
                    </div>
                );
            },
            key: 'shortName',
        });
        if (create) {
            // c.push({
            //     title: '',
            //     dataIndex: '',
            //     key: 'move',
            //     fixed: 'right',
            //     width: 45,
            //     render: (text, record) => {
            //         return (<div style={{lineHeight: "0"}}>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => kat_move("up", record)}><Icofont icon="caret-up"/></Button>
            //             <Button type="text" style={{padding: "0px 4px", height: "100%", lineHeight: "0"}} onClick={() => kat_move("down", record)}><Icofont icon="caret-down"/></Button>
            //             </div>
            //         );
            //     },
            // });
            c.push({
                title: '',
                dataIndex: '',
                key: 'x',
                fixed: 'right',
                width: 45,
                render: (text, record) => {
                    return (
                        <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                            {
                                ...props,
                                readonly: false,
                                mode: "MenuItem",
                                auth: auth,
                                context: object,
                                object: record,
                                action: (values, unlock, close) => updateAction(record, values, unlock, close),
                                form: KategoriiUchastnikovNaMeropriyatiyakhUpdate,
                                title: "Изменить",
                                modal: {
                                    title: "Изменить",
                                    minWidth: "600px",
                                }
                            },
                            {
                                title: "Удалить",
                                mode: "MenuItem",
                                action: () => kat_delete(record)
                            }
                        ]} />);
                },
            });
        }

        return c;
    };
    const updateAction = (record, values, unlock, close) => {
        if (!create) return;
        setLoading(true)
        POST(auth, "/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/update", { 
            ...record, 
            ...values,
            kurator: {userID: values?.kurator?.ID},
        },
            ({data}) => {
                if (data) {
                    setKategorii(updateInArray(_kategorii, data))
                    // updateEvent({
                    //     ...object,
                    //     kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie: updateInArray(object.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, data)
                    // })
                }
                setLoading(false)
                close();
            },
            (err)=>errorCatch(err, ()=>{setLoading(false); unlock();}));
    };
    const createAction = (values, unlock, close) => {
        if (!create) return;
        setLoading(true)
        POST(auth, "/api/meropriyatiya/kategoriiuchastnikovnameropriyatiyakh/new", { 
            ...values, 
            kurator: {userID: values?.kurator?.ID},
            meropriyatieID: object.ID },
            ({ data }) => {
                if (data) {
                    setKategorii(updateInArray(_kategorii, data))
                    // updateEvent({
                    //     ...object,
                    //     kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie: updateInArray(object.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie, data)
                    // })
                }
                setLoading(false)
                close();
            },
            (err) => errorCatch(err, ()=>{setLoading(false); unlock();}));
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const dataSource = kategorii;
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
            postSetOrder(newData);
        }
    };

    const DraggableContainer = props => (
        <SortableContainer
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...props}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const dataSource = kategorii;
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex(x => x.sort === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} />;
    };

    return (
        <>
            {create && <Action 
            // {...props}
                readonly={false}
                triggerStyle={{ marginBottom: "5px" }}
                triggerOptions={{
                    type: "primary",
                    style:{paddingBottom:"50px"}
                }}
                auth={auth}
                action={createAction}
                form={KategoriiUchastnikovNaMeropriyatiyakh}
                title={"Добавить категорию участников"}
                modal={{
                    // width: "55%",
                    minWidth: "400px",
                }}
                mode={"button"}
            />}
            <Table
                loading={loading}
                columns={columns()}
                pagination={false}
                dataSource={kategorii}
                locale={{ emptyText: <Empty description={"Нет категорий участников"}></Empty> }}
                size="small"
                rowKey={r => r.sort}
                components={{
                    body: {
                        wrapper: DraggableContainer,
                        row: DraggableBodyRow,
                    },
                }}
            />
        </>
    );
}
